module.exports = __webpack_public_path__ + "768017bcba7e6828782c7015137a44a5.jpg";